import { computed, Provider, signal } from '@angular/core';

import { ATTENTION_PROJECTIONS, AttentionProjection } from '@shared/services/attention/attention-projections';

/** The rail items the salon's badges decorate — the pages-config urls of its children. */
export const SALON_RAIL = {
  today: '/provider/app/beauty-salon/today',
  register: '/provider/app/beauty-salon/register',
} as const;

/* What the salon store last counted, published here so the ROOT projection reads it without
   importing the store — which would pull the whole salon into the app's initial chunk (the 7 MB
   budget, M2; the restaurant's pattern, M3). Until the salon has been opened this session there is
   nothing counted, and no badge. */
const WAITING = signal(0);
const UNPAID = signal(0);

/** The store's one write — who is checked in and waiting, and what is done but not yet charged. */
export function publishSalonBadges(waiting: number, unpaid: number): void {
  if (WAITING() !== waiting) {
    WAITING.set(waiting);
  }
  if (UNPAID() !== unpaid) {
    UNPAID.set(unpaid);
  }
}

/**
 * The salon's rail badges (kz2 M4), registered at the root: Today counts the clients checked in and
 * waiting for a chair; Take payment counts the finished visits nobody has charged (money owed, the
 * DS's `done && !paid`). Each carries its capability, so a capability that is off shows no count.
 */
export function salonAttentionProjections(): readonly AttentionProjection[] {
  return [
    {
      rule: { id: 'salon.today.waiting', moduleId: 'salon', capKey: null, railItemId: SALON_RAIL.today, enabled: true, scope: 'site' },
      count: WAITING.asReadonly(),
    },
    {
      rule: { id: 'salon.register.unpaid', moduleId: 'salon', capKey: 'register', railItemId: SALON_RAIL.register, enabled: true, scope: 'site' },
      count: UNPAID.asReadonly(),
      tone: computed(() => 'warning' as const),
    },
  ];
}

/** Register the salon's projections at the root (AppModule), so the shell can show them. */
export function provideSalonAttention(): Provider[] {
  return [{ provide: ATTENTION_PROJECTIONS, useValue: salonAttentionProjections, multi: true }];
}
